import { Component, EventEmitter, Output } from "@angular/core";

@Component({
  selector: "app-help-tour-button",
  templateUrl: "./help-tour-button.component.html",
  styleUrls: ["./help-tour-button.component.scss"],
})

/**
 * Help Tour Button Component
 * Simple link component with icon and "Ajuda" text for starting tours in modals
 */
export class HelpTourButtonComponent {
  @Output() tourClick = new EventEmitter<void>();

  onTourClick(event: Event): void {
    event.preventDefault();
    this.tourClick.emit();
  }
}

